import React, { useEffect, useState, useContext, useMemo, MouseEventHandler } from 'react';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import NumericEntry_input_EmptyUse from '../../../../atoms/Input/NumericEntry_input_EmptyUse';
import { NAME_DEV_SET, GetNameDevSetList } from '../../../../../function/NameDevSetModel';

import { DeviceRegistPageStyle, TableBaseStyle } from '../DeviceRegistStyle';
import LayerShortSettingHeader from './LayerShortSettingHeader';
import LayerShortSettingHeader2 from './LayerShortSettingHeader2';

export type LayerShortSettingDialogBodyProps = {
  nameDevSetRow: NAME_DEV_SET;
  updateItem: (item: NAME_DEV_SET) => void;
};

export type LayerShortSettingDialogBodyResponse = { devindex: number; };


const LayerShortSettingDialogBody: React.FC<LayerShortSettingDialogBodyProps> = (props: LayerShortSettingDialogBodyProps) => {
  const { t } = useTranslation();
  const tableBaseStyle = TableBaseStyle();
  const pageStyle = DeviceRegistPageStyle();

  const [smoothW0, setSmoothW0] = useState<string>(props.nameDevSetRow.SMOOTH_W0 !== null ? String(props.nameDevSetRow.SMOOTH_W0) : '');
  const [smoothW1, setSmoothW1] = useState<string>(props.nameDevSetRow.SMOOTH_W1 !== null ? String(props.nameDevSetRow.SMOOTH_W1) : '');
  const [smoothW2, setSmoothW2] = useState<string>(props.nameDevSetRow.SMOOTH_W2 !== null ? String(props.nameDevSetRow.SMOOTH_W2) : '');
  const [thSigma, setThSigma] = useState<string>(props.nameDevSetRow.TH_SIGMA !== null ? String(props.nameDevSetRow.TH_SIGMA) : '');
  const [thLR, setThLR] = useState<String>(props.nameDevSetRow.TH_L_R !== null ? String(props.nameDevSetRow.TH_L_R) : '');
  const [thLS, setThLS] = useState<String>(props.nameDevSetRow.TH_L_S !== null ? String(props.nameDevSetRow.TH_L_S) : '');
  const [thLT, setThLT] = useState<String>(props.nameDevSetRow.TH_L_T !== null ? String(props.nameDevSetRow.TH_L_T) : '');
  const [thHR, setThHR] = useState<String>(props.nameDevSetRow.TH_H_R !== null ? String(props.nameDevSetRow.TH_H_R) : '');
  const [thHS, setThHS] = useState<String>(props.nameDevSetRow.TH_H_S !== null ? String(props.nameDevSetRow.TH_H_S) : '');
  const [thHT, setThHT] = useState<String>(props.nameDevSetRow.TH_H_T !== null ? String(props.nameDevSetRow.TH_H_T) : '');

  useEffect(() => {
    console.debug("LayerShortSettingDialogBody useEffect body", props.nameDevSetRow.SMOOTH_W0);
    setSmoothW0(props.nameDevSetRow.SMOOTH_W0 !== null ? String(props.nameDevSetRow.SMOOTH_W0) : '');
    setSmoothW1(props.nameDevSetRow.SMOOTH_W1 !== null ? String(props.nameDevSetRow.SMOOTH_W1) : '');
    setSmoothW2(props.nameDevSetRow.SMOOTH_W2 !== null ? String(props.nameDevSetRow.SMOOTH_W2) : '');
    setThSigma(props.nameDevSetRow.TH_SIGMA !== null ? String(props.nameDevSetRow.TH_SIGMA) : '');
    setThLR(props.nameDevSetRow.TH_L_R !== null ? String(props.nameDevSetRow.TH_L_R) : '');
    setThLS(props.nameDevSetRow.TH_L_S !== null ? String(props.nameDevSetRow.TH_L_S) : '');
    setThLT(props.nameDevSetRow.TH_L_T !== null ? String(props.nameDevSetRow.TH_L_T) : '');
    setThHR(props.nameDevSetRow.TH_H_R !== null ? String(props.nameDevSetRow.TH_H_R) : '');
    setThHS(props.nameDevSetRow.TH_H_S !== null ? String(props.nameDevSetRow.TH_H_S) : '');
    setThHT(props.nameDevSetRow.TH_H_T !== null ? String(props.nameDevSetRow.TH_H_T) : '');
  }, [])

  console.debug(['NumericEntry_inputExCopy loop']);

  console.debug('LayerShortSettingDialogBody check', props.nameDevSetRow);

  return (
    <>
      {/**レアショート判定のボディーの呼び出し */}
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          <TableContainer className={pageStyle.tableDialgContainer}>
            <Table aria-label="judgeSetting">
              <TableHead>
                <LayerShortSettingHeader />
              </TableHead>
              <TableBody>
                {/** 窓幅設定 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                    {t('LayerShortSettingDialogBody.生波形の平滑化 窓幅', '生波形の平滑化　窓幅W0')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                    <NumericEntry_input_EmptyUse
                      className={tableBaseStyle.textFieldDialog}
                      value={smoothW0 === '' ? null : Number(smoothW0)}
                      minValueLimit={1}
                      maxValueLimit={199}
                      fixed={0}
                      onChange={(val) => {
                        setSmoothW0(String(val === null ? '' : val));
                        props.nameDevSetRow.SMOOTH_W0 = val;
                        props.updateItem(props.nameDevSetRow);
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/** 短い窓幅設定 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                    {t('LayerShortSettingDialogBody.生波形の平滑化 短い窓幅', '生波形の平滑化　短い窓幅W1')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                    <NumericEntry_input_EmptyUse
                      className={tableBaseStyle.textFieldDialog}
                      value={smoothW1 === '' ? null : Number(smoothW1)}
                      minValueLimit={1}
                      maxValueLimit={199}
                      fixed={0}
                      onChange={(val) => {
                        setSmoothW1(String(val === null ? '' : val));
                        props.nameDevSetRow.SMOOTH_W1 = val;
                        props.updateItem(props.nameDevSetRow);
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/** 長い窓幅設定 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                    {t('LayerShortSettingDialogBody.生波形の平滑化 長い窓幅', '生波形の平滑化　長い窓幅W2')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                    <NumericEntry_input_EmptyUse
                      className={tableBaseStyle.textFieldDialog}
                      value={smoothW2 === '' ? null : Number(smoothW2)}
                      minValueLimit={1}
                      maxValueLimit={199}
                      fixed={0}
                      onChange={(val) => {
                        setSmoothW2(String(val === null ? '' : val));
                        props.nameDevSetRow.SMOOTH_W2 = val;
                        props.updateItem(props.nameDevSetRow);
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/** 閾値設定 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                    {t('LayerShortSettingDialogBody.閾値Xα', '閾値Xα')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                    <NumericEntry_input_EmptyUse
                      className={tableBaseStyle.textFieldDialog}
                      value={thSigma === '' ? null : Number(thSigma)}
                      minValueLimit={0.01}
                      maxValueLimit={9.99}
                      fixed={2}
                      onChange={(val) => {
                        setThSigma(String(val === null ? '' : val));
                        props.nameDevSetRow.TH_SIGMA = val;
                        props.updateItem(props.nameDevSetRow);
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      {/** 上の項目と引き離す処理 */}
      <div style={{ margin: '16px 0' }} />
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          <TableHead>
            <LayerShortSettingHeader2 />
          </TableHead>
          <TableBody>
            {/** 閾値設定 軽故障*/}
            <TableRow>
              <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                {t('LayerShortSettingDialogBody.軽故障', '軽故障(%)')}
              </TableCell>
              {/**R相 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={thLR === '' ? null : Number(thLR)}
                  minValueLimit={0.1}
                  maxValueLimit={99.9}
                  fixed={1}
                  onChange={(val) => {
                    console.debug(['NumericEntry_inputExCopy use onchange', val]);
                    setThLR(String(val === null ? '' : val));
                    props.nameDevSetRow.TH_L_R = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
              {/**S相 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={thLS === '' ? null : Number(thLS)}
                  minValueLimit={0.1}
                  maxValueLimit={99.9}
                  fixed={1}
                  onChange={(val) => {
                    console.debug(['NumericEntry_inputExCopy use thLS', val, thLS])
                    setThLS(String(val === null ? '' : val));
                    props.nameDevSetRow.TH_L_S = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
              {/**T相 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={thLT === '' ? null : Number(thLT)}
                  minValueLimit={0.1}
                  maxValueLimit={99.9}
                  fixed={1}
                  onChange={(val) => {
                    setThLT(val === null ? '' : String(val));
                    props.nameDevSetRow.TH_L_T = val;
                    props.updateItem(props.nameDevSetRow);

                  }}
                />
              </TableCell>
            </TableRow>
            {/** 閾値設定 */}
            <TableRow>
              <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                {t('LayerShortSettingDialogBody.重故障', '重故障(%)')}
              </TableCell>
              {/**R相 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={thHR === '' ? null : Number(thHR)}
                  minValueLimit={0.1}
                  maxValueLimit={99.9}
                  fixed={1}
                  onChange={(val) => {
                    setThHR(String(val === null ? '' : val));
                    props.nameDevSetRow.TH_H_R = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
              {/**S相 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={thHS === '' ? null : Number(thHS)}
                  minValueLimit={0.1}
                  maxValueLimit={99.9}
                  fixed={1}
                  onChange={(val) => {
                    setThHS(String(val === null ? '' : val));
                    props.nameDevSetRow.TH_H_S = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
              {/**T相 */}
              <TableCell className={tableBaseStyle.dialogBodyCell} width={100}>
                <NumericEntry_input_EmptyUse
                  className={tableBaseStyle.textFieldDialog}
                  value={thHT === '' ? null : Number(thHT)}
                  minValueLimit={0.1}
                  maxValueLimit={99.9}
                  fixed={1}
                  onChange={(val) => {
                    setThHT(String(val === null ? '' : val));
                    props.nameDevSetRow.TH_H_T = val;
                    props.updateItem(props.nameDevSetRow);
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Grid>
      </Grid>
    </>
  );
}
export default LayerShortSettingDialogBody;